import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {fetchPropertySuitesForTable ,saveSuite,updateSuite,deleteUnit, setWalkThroughStatus, saveBulkSuites, onClearResponseDone} from '../../store/actions/suites';
import { selectSuites } from '../../store/selectors/suites';
import SuitesTable from '../../components/SuitesTable';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/upLoadHelper'
import Loader from '../../components/Loader'
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import moment from 'moment';
import { fetchPropertyCounts } from '../../store/actions/properties';
import { clearFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { getAllUserTypeRoles } from '../../store/actions/formOptions';
import { clearValidation } from '../../store/actions/validation';

class PropertySuites extends Component {
  componentDidMount() {
    const { property, onFetchPropertySuites,clearSearch, user,clearFaqsNotesDocuments, getAllUserTypeRoles } = this.props;
    onFetchPropertySuites(property.propertyId, user.id, user.roles[0].role.name);
    clearFaqsNotesDocuments();
    clearSearch();
    getAllUserTypeRoles();
    this.clearSuitesImportResponse();
  }

  /*
    Created By: Sai Prasad
    Created Date: 01/09/2022
    Jira Ticket: JUN-3152
    Description: To clear response and validation.
  */

  clearSuitesImportResponse = () => {
    const { onClearValidation, onClearResponse } = this.props;
    onClearValidation();
    onClearResponse();
}
  onSaveSuite = async (suite, suiteAreas, floorImage) => {
        
    const {property,onSaveSuite,onUpdateSuite, user, onFetchPropertyCounts} = this.props;
    let imageUrl=null
    let newImage = false;
    if(floorImage === suite.floorPlanURL) {
      imageUrl= suite.floorPlanURL
    } else {
    if(suite.floorPlanURL && suite.floorPlanURL.length > 0){
      newImage = true;
      imageUrl =  await upload(suite.floorPlanURL[0])
    }
  }

    let params = {}
    let parkingStalls = [];
    let storageLockers = [];
    if(suite && suite.parkingStalls && suite.parkingStalls.length > 0) {
      suite.parkingStalls.map(ps => {
        let obj = {
          Name: ps.label,
          Type: 'ParkingStalls'
        }
        parkingStalls = [...parkingStalls, obj]
      })
    }
    if(suite && suite.storageLockers && suite.storageLockers.length > 0) {
      suite.storageLockers.map(ps => {
        let obj = {
          Name: ps.label,
          Type: 'StorageLockers'
        }
        storageLockers = [...storageLockers, obj]
      })
    }
    if(suite.id){
      await suiteAreas.map(item => {
        if(item.type === 'Other') {
          delete item.id
        }
      })
      params={
        "id": suite.id,
        "propertyId": suite.propertyId,
        "number": suite.number.trim(),
        "stratalot": suite.stratalot ? suite.stratalot.trim() : '',
        "Userid":this.props.user.id,
        "Areas": suiteAreas,
        "floorPlanURL": imageUrl,
        "assetWarrantyDefaultStartDate": suite.assetWarrantyDefaultStartDate ? new Date(moment(suite.assetWarrantyDefaultStartDate).format('l LT')) : null,
        "warrantyNumber":suite.warrantyNumber,
        "warrantyAddress":suite.warrantyAddress,
        "Building":suite.Building,
        "BuildingId":suite.BuildingId ? suite.BuildingId : null,
        "Level":suite.Level,
        "LevelId":suite.LevelId ? suite.LevelId : null,
        "ParkingStalls":parkingStalls,
        "StorageLockers":storageLockers,
        "newImage":newImage,
        "KeyFobs": suite.keyFobs,
        "NumberOfKeys": suite.numberOfKeys === null ? 0:Number(suite.numberOfKeys),
        "KeyHandOffInstructions": suite.keyHandOffInstructions,
        "StatusId":suite.statusId,
        "suiteKeysAndValues": suite.suiteKeysAndValues
    }
    
    onUpdateSuite(params)
    }else{
     await suiteAreas.map(item => {
        if(item.type === 'Other') {
          delete item.id
        }
      })
      params ={
        "fromUnitId": suite && suite.fromUnitId ? suite.fromUnitId : null,
        "Number": suite.number.trim(),
        "stratalot": suite.stratalot ? suite.stratalot.trim() : '',
        "PropertyId": property.propertyId,
        "Userid": this.props.user.id,
        "Areas": suiteAreas,
        "floorPlanURL": imageUrl,
        "assetWarrantyDefaultStartDate": suite.assetWarrantyDefaultStartDate ? new Date(moment(suite.assetWarrantyDefaultStartDate).format('l LT')) : null,
        "warrantyNumber":suite.warrantyNumber,
        "warrantyAddress":suite.warrantyAddress,
        "Building":suite.Building,
        "BuildingId":suite.BuildingId ? suite.BuildingId : null,
        "Level":suite.Level,
        "LevelId":suite.LevelId ? suite.LevelId : null,
        "ParkingStalls":parkingStalls,
        "StorageLockers":storageLockers,
        "KeyFobs": suite.keyFobs,
        "NumberOfKeys": suite.numberOfKeys === null || suite.numberOfKeys === "" || suite.numberOfKeys === undefined? 0:Number(suite.numberOfKeys),
        "KeyHandOffInstructions": suite.keyHandOffInstructions,
        "StatusId":suite.statusId,
        "suiteKeysAndValues": suite.suiteKeysAndValues
      }    

     await onSaveSuite(params);
     onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)
    }
  }

  onDeleteUnit = async (unitId) => {
    let {onDeleteUnit, property, onFetchPropertyCounts, user} = this.props;
    await onDeleteUnit(unitId, user.id)
    onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)
  }
  setWalkThroughStatus (status,data) {
    const { setWalkThroughStatus} = this.props;
   setWalkThroughStatus(status,data)
  }

  /*
    Modified By: Sai Prasad
    Modified Date: 30/08/2022
    Jira Ticket: JUN-2692
    Description: prepare json object for bulkimport.
  */

  saveBulkImport = (suitesArray) => {
    const { property, user, onSaveBulkSuites } = this.props;
    const params = {
      propertyId: property.id,
      userId: user.id,
      suiteList: suitesArray
    };
    onSaveBulkSuites(params, user.roles[0].role.name);
  }

  render() {

    const { suites, property,setSearch,loader } = this.props;

      return (
        loader ? <Loader /> :
        <SuitesTable
          suites={suites}
          property={property}
          onDeleteUnit={(data) =>this.onDeleteUnit(data)}
          setWalkThroughStatus={(status,data) => this.setWalkThroughStatus(status,data)}
          onSaveSuite={(suite, areas, floorImage) => this.onSaveSuite(suite, areas, floorImage)}
          onSearch={e => setSearch({ suites: e.target.value.trim() })}
          onSaveBulkImport={this.saveBulkImport}
        />
      );
    }

}

const mapStateToProps = (state, ownProps) => ({
  suites: selectSuites(state),
  user: selectAuthenticatedUser(state),
  loader: selectPRLoader(state),
  formOptions:selectFormOptions(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchPropertySuites: fetchPropertySuitesForTable,
  onSaveSuite: saveSuite,
  onUpdateSuite: updateSuite,
  onDeleteUnit: deleteUnit,
  setSearch,
  clearSearch,
  setWalkThroughStatus: setWalkThroughStatus,
  onFetchPropertyCounts: fetchPropertyCounts,
  clearFaqsNotesDocuments:clearFaqsNotesDocuments,
  getAllUserTypeRoles,
  onSaveBulkSuites: saveBulkSuites,
  onClearValidation: clearValidation,
  onClearResponse: onClearResponseDone
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertySuites);